export enum CREATE_USER_STEPS {
    USER_DETAILS = 0,
    SETTINGS = 1,
    LIMITS = 2,
    ROLE_SETTINGS = 3,
}

export const STEP_ROTES = {
    [CREATE_USER_STEPS.USER_DETAILS]: 'details',
    [CREATE_USER_STEPS.SETTINGS]: 'settings',
    [CREATE_USER_STEPS.LIMITS]: 'limits',
    [CREATE_USER_STEPS.ROLE_SETTINGS]: 'role-settings',
};

export const STEP_TITLE = {
    [CREATE_USER_STEPS.USER_DETAILS]: 'User details',
    [CREATE_USER_STEPS.SETTINGS]: 'Settings',
    [CREATE_USER_STEPS.LIMITS]: 'Limits',
    [CREATE_USER_STEPS.ROLE_SETTINGS]: 'Role Settings',
};

export const NO_USER_EMAIL = 'NO_USER_EMAIL';
export const UNVALID_EMAIL = 'UNVALID_EMAIL';
export const DUPLICATED_EMAIL = 'DUPLICATED_EMAIL';
export const SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE';
export const NO_USER_FIRST_NAME = 'NO_USER_FIRST_NAME';
export const NO_USER_LAST_NAME = 'NO_USER_LAST_NAME';
export const INVALID_HUBSPOT_CRM_ID = 'INVALID_HUBSPOT_CRM_ID';

export const VALIDATION_ERRORS = {
    NO_USER_EMAIL: 'Account email is a required field.',
    UNVALID_EMAIL: 'Email address is not valid. Please, update it and try again.',
    DUPLICATED_EMAIL: 'A user with this email already exists. Please use a unique email address and try again.',
    SERVICE_UNAVAILABLE: 'Service is temporary unavailable. Please try later.',
    NO_USER_FIRST_NAME: 'First name is a required filed.',
    NO_USER_LAST_NAME: 'Last name is a required filed.',
    INVALID_HUBSPOT_CRM_ID: 'HubSpot User ID should be in range from 0 to 2147483647',
};

export const VALIDATE_CONTROL_IDS = {
    EMAIL: 'user-email-address',
    FIRST_NAME: 'user-first-name',
    LAST_NAME: 'user-last-name',
};
